import { API_NAME, DEFAULT_ERROR_MESSAGE, PDF_EXPORT_ERROR_MESSAGE } from '../const';
import { saveAs } from 'file-saver';
import API from '@aws-amplify/api'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

interface PdfExportResponse {
  status: string;
  url: string;
}

export async function pdfExport(
  apply_ids: []
): Promise<PdfExportResponse> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .put(API_NAME, `/v2/pdf`, {
      body: {
        apply_ids: apply_ids,
      }
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      alert(PDF_EXPORT_ERROR_MESSAGE);
      throw err;
    });

  if (response && response.status === 'success') {
    // PDFを取得して保存
    await fetch(response.url, {
      method: 'GET',
    })
      .then(resp => {
        if (resp.status !== 200) {
          throw new Error();
        }
        return resp.text();
      })
      .then(text => {
        const blob = new Blob([text]);
        saveAs(blob, getFileName());
      })
      .catch(err => {
        alert(DEFAULT_ERROR_MESSAGE);
        throw err;
      });
  }

  return response;
}

const getFileName = () => {
  const nowDate = new Date();

  const year = nowDate.getFullYear();
  const month = ('0' + (nowDate.getMonth() + 1)).slice(-2);
  const day = ('0' + nowDate.getDate()).slice(-2);
  const hours = ('0' + nowDate.getHours()).slice(-2);
  const seconds = ('0' + nowDate.getSeconds()).slice(-2);

  const formatDay = year + month + day + hours + seconds;
  return `${formatDay}.pdf`;
};
